/* eslint-disable no-magic-numbers */
export const formatDate = (d: Date) => {
  const year = d.getFullYear();
  const month = ('0' + (d.getMonth() + 1)).slice(-2);
  const day = ('0' + d.getDate()).slice(-2);

  return `${year}-${month}-${day}`;
};

export const formatTime = (d: Date) => {
  const hours = ('0' + d.getHours()).slice(-2);
  const minutes = ('0' + d.getMinutes()).slice(-2);
  const seconds = ('0' + d.getSeconds()).slice(-2);

  return `${hours}:${minutes}:${seconds}`;
};

export const isMobileDevice = () => window.innerWidth < 480;
